import React from "react";
import NotificationSystem from "react-notification-system";
import { useSelector } from 'react-redux';
import { Switch, useHistory } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { WithAuth } from "../components/Authorization/WithAuth";
import Footer from "../components/Footer/Footer";
import AdminNavbar from "../components/Navbars/AdminNavbar";
import SessionTimeout from "../components/SessionControls/SessionTimeout";
import { Sidebar } from "../components/Sidebar/Sidebar";
import { CustomRoute } from "../components/api-authorization/CustomRoute";
import { SystemNotification } from "../containers/Settings/AdminNotifications/SystemNotification";
import routes from "../routes";
import { SignalRProvider } from "../signalR/signalRProvider";
import { style } from "../variables/Variables.jsx";
import { ApplicationPaths } from "../components/api-authorization/ApiAuthorizationConstants";

const AdminLayout = (props) => {

  let navigation = useHistory();
  const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);

  const getRoutes = routes => {
    return routes.map((route, i) => {

      if (route.collapse) {
        return getRoutes(route.routes);
      }
      if (route.layout === "/admin") {
        return (
          <CustomRoute
            exact
            path={route.layout + route.path}
            key={i}
            route={route}
            routes={routes}
          />
        );
      } else {
        return null;
      }
    });
  };

  const handleLogOut = () => {
    navigation.push({ pathname: `${ApplicationPaths.LogOut}`, state: { local: true } });
  }

  return (
    <SignalRProvider>
      <WithAuth requiredPermission={["Database.List"]}>
        <SystemNotification />
      </WithAuth>
      <WithAuth requiredPermission={["MedicalRecords.Create"]}>
        <SessionTimeout isAuthenticated={isAuthenticated} logOut={handleLogOut} />
      </WithAuth>
      <div className="wrapper">
        <ToastContainer
          position="top-right"
          autoClose={3500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          pauseOnHover
          theme="light"
          enableMultiContainer={true}
        />
        <NotificationSystem style={style} />
        <Sidebar {...props} />
        <div className="main-panel">
          <AdminNavbar
            {...props}
            navbar={false}
          />
          <div className="main-content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <Switch>
                    {getRoutes(routes)}
                  </Switch>
                </div>
              </div>
            </div>
          </div>
          <Footer fluid />
        </div>
      </div>
    </SignalRProvider>
  );
}

export default AdminLayout;